import { Box, Button, TextField, Typography, Zoom } from '@mui/material';
import axios from 'axios';
import { useSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react'
// import { useNavigate } from 'react-router';
import useAuth from 'src/hooks/useAuth';
import useLayoutContext from 'src/hooks/useAuthLayout';
import confirmSweetAlert from 'src/utils/confirm'


export default function AgregarCelular() {

    // const navigate = useNavigate()
    const { enqueueSnackbar } = useSnackbar();
    const { user } = useAuth()
    const { modalOpen, mostrarComponent } = useLayoutContext()
    const [celular, setCelular] = useState({
        value: ''
    });
    const [obj, setobj] = useState(null);
    const [agendaDoctor, setAgendaDoctor] = useState(null);
    const [arrayexiste, setArrayexiste] = useState([])


    useEffect(() => {
        console.log(modalOpen)
    }, [modalOpen]);

    useEffect(() => {
        console.log(user)
    }, [user]);

    const handleChangedText = (ev) => {
        setCelular({
            ...celular,
            value: ev.target.value || ""
        })
        console.log(celular)
    }

    useEffect(() => {
        // setCelular(992830820)
        console.log(celular)
    }, [celular]);

    useEffect(() => {
        const getDatos = async (obj) => {
            const response = await axios.post(`https://apis-anterior.vesaliohce.com.pe/medicosEspecialidadHorarioNew`, obj)
            console.log(response.data.cabecera[0])
            setAgendaDoctor(response.data)
            console.log(agendaDoctor)
        }
        getDatos({ agenda: modalOpen.item.cita.agignacionSelecteds.asignacion_id, fecha: modalOpen.item.cita.item.fecha_calendario.split('T')[0] })

    }, [modalOpen])


    useEffect(() => {
        if (agendaDoctor !== null) {
            setobj(
                {

                    id_usuario: user._id,
                    fecha: modalOpen.item.cita.item.fecha_calendario.split('T')[0],
                    hora: modalOpen.item.horaCita.horas,
                    asignacion: modalOpen.item.cita.agignacionSelecteds.asignacion_id,
                    agenda: agendaDoctor.cabecera[0].id_agenda,

                    datos: {
                        doctor: agendaDoctor.cabecera[0],
                        turno: modalOpen.item.cita.item.fecha_calendario.split('T')[0] + 'T' + modalOpen.item.horaCita.horas,
                        paciente: modalOpen.item.paciente
                    },

                    celular: celular.value,
                    paciente: modalOpen.item.paciente

                }
            )
        }
        console.log(agendaDoctor)
    }, [agendaDoctor, celular]);


    useEffect(() => {
        const getDatosBloqueo = async () => {
            const response = await axios.get(`https://apis.vesaliohce.com.pe/admin/getMedicosBloqueo`)
            if (response.status === 200) {
                setArrayexiste(response.data.map(x => parseInt(x.dni)))
            }
        }
        getDatosBloqueo()


    }, [])
    const getGenerarCita = async (datos) => {
        console.log(datos)

        const response = await axios.post(`https://apis-anterior.vesaliohce.com.pe/generarCitaAdminNew`, datos)
        console.log(response.data)
        console.log(response)
        return response.data;
    }

    const getExisteTurno = async (obj) => {
        const response = await axios.post(`https://apis-anterior.vesaliohce.com.pe/existeTurnoPacienteNew`, obj)
        return response.data;
    }


    const reservarCita = async () => {

        const rpta = await confirmSweetAlert('Confirmar cita', '¿Esta seguro que desea confirmar la cita?', 'info', true)
        if (rpta) {
            // aqui va las validaciones 

            let existeTurno = await getExisteTurno({
                datos: [{ id: 'paciente', value: modalOpen.item.paciente.paciente.item.Nro_DocIdenti },
                { id: 'asignacion', value: modalOpen.item.cita.agignacionSelecteds.asignacion_id },
                { id: 'fecha', value: modalOpen.item.cita.item.fecha_calendario.split('T')[0] }]
            })
            if (existeTurno[0].cantidad === 0) {
                let existe = arrayexiste.find(x => x === parseInt(agendaDoctor.cabecera[0].documento))
                if (existe !== undefined) {
                    await confirmSweetAlert('Cita restringida', 'Las citas solo se genera con la secretaria del doctor o en el modulo del doctor', 'error', false)
                } else {
                    let result = await getGenerarCita(obj)
                    if (typeof result === 'object') {

                        mostrarComponent({
                            contenido: 'citaRealizada',
                            estado: true,
                            size: 'xs'
                        }, 'modalOpen')

                        setTimeout(() => {
                            window.location.reload(true)
                        }, 1000)


                    } else {
                        enqueueSnackbar('Error: Es posible que se haya generado una cita en simultáneo. Intente con otro horario.', {
                            variant: 'error',
                            anchorOrigin: {
                                vertical: 'top',
                                horizontal: 'right'
                            },
                            TransitionComponent: Zoom
                        })
                    }
                }


            } else {
                enqueueSnackbar('Error: No puede generar una cita con el mismo doctor en el mismo día', {
                    variant: 'error',
                    anchorOrigin: {
                        vertical: 'top',
                        horizontal: 'right'
                    },
                    TransitionComponent: Zoom
                })
            }


        }


    }



    return (
        <>
            <Box style={{ display: "flex", flexDirection: "column", justifyContent: "center", justifyItems: "center", alignContent: "center", alignItems: "center" }}>
                <Box style={{ marginTop: "20px" }}>
                    <Typography>Ingrese su Celular para comunicación con el paciente</Typography>
                </Box>
                <Box style={{ margin: "20px" }}>
                    <TextField
                        style={{ width: "350px" }}
                        label="Digite aquí su número de celular"
                        variant="outlined"
                        fullWidth
                        value={celular.value}
                        onChange={(e) => handleChangedText(e)} />
                </Box>
                <Button onClick={reservarCita} variant='contained' style={{ marginBottom: "20px" }}>Generar Cita</Button>
            </Box>

        </>
    )
}
